var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[(_vm.profile.username)?_c('p',[_c('strong',[_vm._v("Name:")]),_vm._v(" "+_vm._s(_vm.profile.username)),_c('br'),_c('strong',[_vm._v("Email:")]),_vm._v(" "+_vm._s(_vm.profile.email)+"\n    ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }